import { AddCircle, Clear, Edit, Search } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogEdit from "./modal/dialogEdit";
import DialogNew from "./modal/dialogNew";
import messages from "../../../utils/messages";
import serviceMotivoLancamento from "../../../services/serviceMotivoLancamentoManual";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";

const MotivoLancamentoManual = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Lançamento manual - Motivo");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [openNew, setOpenNew] = useState(false);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [editState, setEditState] = useState({
        open: false,
        id: "",
        tipoLancamentoManual: "",
        tituloLancamentoManual: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            tipoLancamentoManual: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operação",
                field: "operations",
                type: "actions",
                width: 120,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() => {
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                tipoLancamentoManual: params.row.tipoLancamentoManual,
                                tituloLancamentoManual: params.row.tituloLancamentoManual,
                            });
                        }}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "motivoLancamentoManualID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Categoria",
                field: "tipoLancamentoManual",
                type: "string",
                width: 180,
            },
            {
                headerName: "Titulo",
                field: "tituloLancamentoManual",
                type: "string",
                flex: 1,
            },

            ...actionColumns,
        ],
        [actionColumns]
    );

    const statusOptions = [
        { value: "Todos", label: "Todos" },
        { value: "Dedução", label: "Dedução" },
        { value: "Acréscimo", label: "Acréscimo" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceMotivoLancamento
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const handleClickOpenNew = async () => {
        setOpenNew(true);
    };

    const onClear = () => {
        reset();
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipoLancamentoManual: values.tipoLancamentoManual === "Todos" ? "" : values.tipoLancamentoManual,
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <AutoComplete
                                                name="tipoLancamentoManual"
                                                label="Categoria"
                                                control={control}
                                                error={errors}
                                                options={statusOptions}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                style={{ marginTop: 16, marginBottom: 8 }}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddCircle />}
                                                onClick={handleClickOpenNew}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                            >
                                                Novo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.motivoLancamentoManualID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogNew
                        open={openNew}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            setOpenNew(false);
                        }}
                    />

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            tipoLancamentoManual: editState.tipoLancamentoManual,
                            tituloLancamentoManual: editState.tituloLancamentoManual,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                tipoLancamentoManual: "",
                                tituloLancamentoManual: "",
                            });
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default MotivoLancamentoManual;
